var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{staticClass:"relative"},[(!_vm.hideText)?_c('span',[_vm._v(_vm._s(_vm.lifeArea))]):_vm._e(),(_vm.showIcon)?_c('vx-tooltip',{staticClass:"text-center",attrs:{"text":_vm.lifeArea,"delay":"0.5s"}},[_c('feather-icon',{staticClass:"mr-1",class:_vm.sizeClass,style:(_vm.style),attrs:{"icon":_vm.icon}})],1):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }